import VimeoVideo from "./VimeoVideo"
import { Image } from "react-bootstrap";
import React,{useMemo} from "react";
import Button from "./Button";
import { formatDateToDDMMYY } from "../../Shared/utils";
import { ReadMore } from "./ReadMore";
import SlickSlider from "./SlickSlider";
import { ProgressBar } from 'react-bootstrap';
import DonationCampaign from "./DonationCampaign";
import VideoPreview from '../../../assets/img/video_preview.webp'

export default function UserCampaignDetails(props){
    const {campaignDetails, previewPart} = props;
    const renderCampaignPreview = (item) => {
        if(item?.view_file_url && (typeof item?.url !== 'undefined' || typeof item !== 'string')){
            return (
                <div className='image-view'>
                    <Image src={item?.view_file_url} alt={item?.file_name} />
                </div>
            )
        }else {
            return(
                <VimeoVideo faceVideo={item?.url ?? item} isDelete={true} />
            )
        }
    }

    const getMosaicImage = useMemo(()=>{
        if(campaignDetails?.details?.initial_source_image){
            return campaignDetails?.details?.initial_source_image;
        }else if(campaignDetails?.details?.source_image){
            return campaignDetails?.details?.source_image;
        }
    },[campaignDetails?.details?.source_image, campaignDetails?.details?.initial_source_image])



    // console.log("data of signature logo",campaignDetails?.details?.signature_logo)
    return(
        <div className="user-campaign w-100 p-0 mt-8" style={{marginTop:"100px"}}>
           <div className='campaign-details-banner' id="sponsor_logo">
            <div className='container' id='campaign_file_source'>
             <div className='text-center d-flex justify-content-center align-items-center flex-column' id='source_image' >
             <h1 className='font-bold campaign-title'>{campaignDetails?.title ?campaignDetails?.title :"Untitled Campaign"}</h1>
              <h5 className='campaign-subtitle font-bold mb-3'>{campaignDetails?.subtitle?campaignDetails?.subtitle:"--"}</h5>
              {campaignDetails?.details?.sponsor_logo && <h6 className='presented-by font-bold'>Presented by</h6>}
              {campaignDetails?.details?.sponsor_logo && <Image className='sponsor-logo mb-2'  src={campaignDetails?.details?.sponsor_logo?.view_file_url} />}
              <div className='campaign-banners w-100' >
                            <div className={`campaign-preview mb-4`}>
                                {campaignDetails?.details?.campaign_file_source?.length > 0 ? (
                                    <React.Fragment>
                                        {campaignDetails?.details?.campaign_file_source?.map?.((item, index)=> index === 0 && (
                                            <React.Fragment key={index}>
                                                <div className={`preview-${campaignDetails?.details?.campaign_file_type}`}>
                                                    {renderCampaignPreview(item)}
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </React.Fragment>
                                ):previewPart?(
                                    <React.Fragment>
                                        <div className={`preview-image`}>
                                            {renderCampaignPreview({view_file_url: VideoPreview})}
                                        </div>
                                    </React.Fragment>
                                ):null}
                                {getMosaicImage && (
                                    <div className={`preview-image`}>
                                        {/* {renderCampaignPreview(campaignDetails?.details?.source_image)} */}
                                        {renderCampaignPreview(getMosaicImage)}
                                    </div>
                                )}
                            </div>
                            {campaignDetails?.details?.financial_progress &&(
                                <div className='common-progress pt-2 px-3'>
                                    <ProgressBar max={(campaignDetails?.goal?.campaign_goal||campaignDetails?.details?.campaign_goal||0)/100} now={(campaignDetails?.goal?.total_donation_amount || 0)/100} variant='success' />
                                </div>)}
              </div>
             </div>
            </div>
           </div>
        {previewPart && (
        <div className='campaign-details-content'>
            <div className='container'>
                <div className='px-3' id='campaign_second_file_source'>
                    <div className='row' >
                        <div className='col-12 col-lg-4'>
                            {campaignDetails?.details?.financial_progress  && (
                                <span className='font-light fs-20 d-block'>
                                    <b className='font-bold contribution-price'>${(campaignDetails?.goal?.total_donation_amount || 0)/100}</b> <span>Of</span> <label className=''>${(campaignDetails?.goal?.campaign_goal||campaignDetails?.details?.campaign_goal||0)/100}</label>
                                </span>
                            )}
                            <span className='d-block' style={{fontSize:"20px"}}>
                                Campaign End Date: {formatDateToDDMMYY(campaignDetails?.end_date)}
                            </span>
                        </div>
                        <div className='col-12 col-lg-8 3 d-flex align-items-center flex-wrap'>
                            <div className='col-sm-6 px-lg-2 mb-2 col-12 px-sm-2'><Button disabled={props?.previewPart} fw={600} className={"w-100 green_button_class button_raduis background_border"} variant={"success"} size={"xl"} radius={"rounded"}>UPLOAD YOUR IMAGE</Button></div>
                            <div className='col-sm-6 px-lg-2 mb-2 col-12 px-sm-2'><Button disabled={props?.previewPart} fw={600} className={"w-100 green_button_class button_raduis"} variant={"outline-success"} size={"xl"} radius={"rounded"} >SHARE</Button></div>
                        </div>
                        <div className='col-12' style={{marginTop:"1rem"}}>
                            <ReadMore text={campaignDetails?.description || ""} />
                        </div>
                        {(campaignDetails?.details?.campaign_second === true && campaignDetails?.details?.campaign_second_file_source?.length>0) && (
                            <div className='col-12 campaign-second'>
                                {campaignDetails?.details?.campaign_second_file_source?.map?.((item, index)=>(
                                   <React.Fragment key={index}>
                                        <div className={`preview-${campaignDetails?.details?.campaign_second_file_type}`}>
                                            {renderCampaignPreview(item)}
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
        )}
        {campaignDetails?.details?.signature_logo?.length>0 && (
            <React.Fragment>
                {campaignDetails?.details?.sponsor_signature === "Yes" && (
                    <div className='campaign-details-signature banner-campaign' id="signature_logo">
                        <div className='container'>
                            <h5 className='banner-title text-center font-bold'>Signature Sponsors</h5>
                            <div className='pt-5'>
                                <SlickSlider
                                    sliderImages={campaignDetails?.details?.signature_logo}
                                    slidesToShow={4}
                                    onRender={(item, index) => (
                                        <div className="sponsor-signature" key={index}>
                                                <Image src={item?.view_file_url} alt="logo"/>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )}
       {previewPart&& (
            <div id='non_profit_file_source'>
                <div className={`campaign-details-contribution banner-campaign`} id="company_file_source">
                    <div className='container d-flex'>
                        <div className="about_section mb-0">
                            {campaignDetails?.details?.company_file_source && campaignDetails?.details?.company_title && campaignDetails?.details?.company_description && (
                                <div className='row' style={{height:"auto"}}>
                                    <div className='col-md-5'>
                                        <div className='about_Main mb-3'>
                                            {campaignDetails?.details?.company_file_source && (
                                                <React.Fragment>
                                                    {campaignDetails?.details?.company_file_type === "image" ? (
                                                            <Image src={campaignDetails?.details?.company_file_source?.view_file_url} alt=""/>
                                                        ):(
                                                            renderCampaignPreview(campaignDetails?.details?.company_file_source)
                                                        )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                        {campaignDetails?.details?.company_website && (
                                            <Button disabled={props?.previewPart} onClick={()=>window.open(campaignDetails?.details?.company_website)} className={"green_button_class button_raduis white-text green_button_class  background_border"} variant={"success"} size={"xl"} radius={"rounded"} >WEBSITE</Button>
                                        )}
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='about_wrappmain'>
                                            <h5 className='font-bold about-title'>{campaignDetails?.details?.company_title}</h5>
                                            {(campaignDetails?.details?.company_description) && (<p style={{color:"white"}} className={`content-view-for-des content-view ql-editor ${previewPart?"view-part":""}`} dangerouslySetInnerHTML={{__html: campaignDetails?.details?.company_description}}></p>)}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {campaignDetails?.details?.non_profit === "Yes" && campaignDetails?.details?.non_profit_file_source && campaignDetails?.details?.non_profit_title && campaignDetails?.details?.non_profit_description &&(
                                <div className='row pt-5'>
                                    <div className='col-md-5'>
                                        <div className='about_Main mb-3'>
                                            {campaignDetails?.details?.non_profit_file_source && (
                                                <React.Fragment>
                                                    {campaignDetails?.details?.non_profit_file_type === "image" ? (
                                                        <Image src={campaignDetails?.details?.non_profit_file_source?.view_file_url} alt=""/>
                                                    ):(
                                                        renderCampaignPreview(campaignDetails?.details?.non_profit_file_source)
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                        {campaignDetails?.details?.non_profit_website && (
                                            <Button disabled={props?.previewPart} onClick={()=>window.open(campaignDetails?.details?.non_profit_website)} className={"green_button_class button_raduis white-text green_button_class  background_border"} variant={"success"} size={"xl"} radius={"rounded"} >WEBSITE</Button>
                                        )}
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='about_wrappmain'>
                                            <h5 className='font-bold about-title'>{campaignDetails?.details?.non_profit_title}</h5>
                                            {(campaignDetails?.details?.non_profit_description) && (<p style={{fontColor:"white"}} className={`content-view-for-des content-view ql-editor ${previewPart?"view-part":""}`} dangerouslySetInnerHTML={{__html: campaignDetails?.details?.non_profit_description}}></p>)}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        )}
        {(campaignDetails?.details?.supporting_sponsor_logos?.length > 0 && campaignDetails?.details?.supporting_sponsors_campaign === "Yes") && (
            <React.Fragment>
                {campaignDetails?.details?.supporting_sponsors_campaign === "Yes" && (
                    <div className='campaign-details-signature banner-campaign' id='supporting_sponsor_logos'>
                        <div className='container'>
                            <h5 className='banner-title text-center font-bold'>Supporting Sponsors</h5>
                            <div className='pt-5'>
                                <SlickSlider
                                    sliderImages={campaignDetails?.details?.supporting_sponsor_logos}
                                    slidesToShow={4}
                                    onRender={(item, index) => (
                                        <div className="supporting-sponsor" key={index}>
                                            <img src={item?.view_file_url} alt="logo"/>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )}
        {previewPart && 
        <div className='campaign-details-donation banner-campaign  d-flex'>
            <DonationCampaign
                campaignDetails={campaignDetails}
                description={campaignDetails?.details?.upload_slogan}
                slug={campaignDetails?.slug}
                editMode={props?.editMode}
            />
        </div>}
        </div>
    )
}